// Avoid `console` errors in browsers that lack a console.
(function () {
    var method;
    var noop = function () {
    };
    var methods = ['assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error', 'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log', 'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd', 'timeStamp', 'trace', 'warn'];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());

// Place any jQuery/helper plugins in here.
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
    // $.post(Storage.getData('app_url'));
}
function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) != -1) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

if (window.history.pushState === undefined) {
    //adding fake support for fucked up browsers
    window.history.pushState = function (state, url, title) {
        document.location.href = url;
    }
}

function updateUrl(title, url) {
    window.history.pushState(null, title, url);
    document.title = title;
}

function updateLlb(data) {
    $('#loginLogout').text(data.loginLogout).attr('href', data.loginLogoutUrl);
}

function stristr(haystack, needle, bool) {
    var pos = 0;

    haystack += '';
    pos = haystack.toLowerCase()
        .indexOf((needle + '')
            .toLowerCase());
    if (pos == -1) {
        return false;
    } else {
        if (bool) {
            return haystack.substr(0, pos);
        } else {
            return haystack.slice(pos);
        }
    }
}

function isReadyToBuy() {
    if (false == $('.ownerDetails .ok').hasClass('hidden') &&
        false == $('.adminDetails .ok').hasClass('hidden')
    ) {
        $('.success-btn-girl img').removeClass('hidden');
        $('.isReady .ok').removeClass('hidden').parent().find('.error').addClass('hidden');
        $('#domainCheckout').removeAttr('disabled');
        return true;
    } else {
        $('.isReady .error').removeClass('hidden').parent().find('.ok').addClass('hidden');
        $('#domainCheckout').attr('disabled', 'disabled');
        $('#creditCardDetails').addClass('hidden');

        return false;
    }
}

function nl2br(str, is_xhtml) {
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}

function ctype_print(str) {
    var allowed = 'abcdefghijklmnopqrstuvwxyz0123456789*!@#$%^?:&*~=_.,<>{}"|-;`+()[]/\\\' ';
    allowed = allowed.split('');

    str = str.replace(/\u200E/g, '');
    var chars = str.split('');
    var status = true;

    for (var i = 0; i < chars.length; i++) {
        var singleChar = chars[i].toLowerCase();
        if (allowed.indexOf(singleChar) === -1) {
            status = false;
            break;
        }
    }
    return status;
}

function enom_ctype_print(str) {
    var allowed = 'abcdefghijklmnopqrstuvwxyz0123456789*!@#$%^?:&*~=_.,<>{}"|-;`+()[]/\\\' ';
    allowed = allowed.split('');

    str = str.replace(/\u200E/g, '');
    var chars = str.split('');
    var status = true;

    for (var i = 0; i < chars.length; i++) {
        var singleChar = chars[i].toLowerCase();
        if (allowed.indexOf(singleChar) === -1) {
            status = false;
            break;
        }
    }
    return status;
}

function ctype_print_heb(str) {
    var allowed = 'אבגדהוזחטיךכלםמןנסעףפץצקרשתabcdefghijklmnopqrstuvwxyz0123456789*!@#$%^?:&*~=_.,<>{}"|-;`+()[]/\\\' ';
    allowed = allowed.split('');

    str = str.replace(/\u200E/g, '');
    var chars = str.split('');
    var status = true;

    for (var i = 0; i < chars.length; i++) {
        var singleChar = chars[i].toLowerCase();
        if (allowed.indexOf(singleChar) === -1) {
            status = false;
            break;
        }
    }
    return status;
}

function validatePerf(num) {
    if ('string' == typeof num && num.charAt(0) == '0') {
        num = num.slice(1, 5);
    }
    return num;
}

jQuery.extend({

    getQueryParameters: function (str) {
        return (str || document.location.search).replace(/(^\?)/, '').split("&").map(function (n) {
            return n = n.split("="), this[n[0]] = n[1], this
        }.bind({}))[0];
    }

});